export const GET_TRUCK_ROUTE_LIST = 'GET_TRUCK_ROUTE_LIST';
export const GET_TRUCK_ROUTE_LIST_LOADING_ERROR =
  'GET_TRUCK_ROUTE_LIST_LOADING_ERROR';
export const GET_TRUCK_ROUTE_LIST_LOADING = 'GET_TRUCK_ROUTE_LIST_LOADING';
export const CLEAR_TRUCK_ROUTE_LIST_ERROR = 'CLEAR_TRUCK_ROUTE_LIST_ERROR';
export const PRINT_TRUCK_ROUTE_DETAIL_LOADING =
  'PRINT_TRUCK_ROUTE_DETAIL_LOADING';
export const PRINT_TRUCK_ROUTE_DETAIL_LOADING_ERROR =
  'PRINT_TRUCK_ROUTE_DETAIL_LOADING_ERROR';
export const DELETE_TRUCK_ROUTE = 'DELETE_TRUCK_ROUTE';
export const DELETE_TRUCK_ROUTE_LOADING = 'DELETE_TRUCK_ROUTE_LOADING';
export const DELETE_TRUCK_ROUTE_LOADING_ERROR =
  'DELETE_TRUCK_ROUTE_LOADING_ERROR';
export const CLEAR_DELETE_TRUCK_ROUTE_SUCCESS =
  'CLEAR_DELETE_TRUCK_ROUTE_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteslist/types.js